import { createFileRoute } from "@tanstack/react-router";
import { ConnectAWS } from "../../../features/infrastructure/cloud-connect";

type Back = { account?: string; awsAccount?: string };

// `account` and `awsAccount` arrive on the AWS stack's ReturnToNodus link.
export const Route = createFileRoute("/_authed/$org/infrastructure/cloudaccounts/new/aws")({
  component: Page,
  validateSearch: (s: Record<string, unknown>): Back => ({
    account: typeof s.account === "string" ? s.account : undefined,
    awsAccount: typeof s.awsAccount === "string" ? s.awsAccount : typeof s.awsAccount === "number" ? String(s.awsAccount) : undefined,
  }),
});

function Page() {
  const { org } = Route.useParams();
  const back = Route.useSearch();
  return <ConnectAWS org={org} back={back} />;
}
